// extracted by mini-css-extract-plugin
export var homepageImg = "index-module--homepage-img--jz0fR";
export var homepageMainText = "index-module--homepage-main-text--OETMH";
export var bodyUnscrollable = "index-module--body-unscrollable--HBRjC";